import React from 'react';
import {Box, Text} from "@chakra-ui/layout";
import {Grid, Heading} from "@chakra-ui/react";

export type VideoDetails = {
  poster: string;
  src: string;
  course: string;
  session: number | 1;
  topic: number | 1;
  description: string;
  teacher: string;
}

function Lesson({poster, src, course, session, topic, description, teacher}: VideoDetails) {
  return (
    <Grid _notFirst={{marginTop: 9}} templateColumns={"repeat(auto-fit, minmax(200px, 1fr))"} mt={2.5}>
      <Box borderRadius={2.5} mr={{lg: 2.5}} mb={{base: 2.5, lg: 0}}>
        <video width={"full"} height={"full"}
               poster={poster}
               src={src}
               controls>
          Your browser does not support the video tag.
        </video>
      </Box>
      <Box mt={{base: 2.5, lg: "0"}}>
        <Heading fontSize={18} fontWeight={"bold"} textTransform={"capitalize"}
        >{course}</Heading>
        <Text m={"1 0"} fontSize={10} fontWeight={"normal"} color={"brand.grey"} textTransform={"capitalize"}>
          <span>session {session}</span>{" . "}<span>topic {topic}</span>
        </Text>
        <Text lineHeight={"15px"} noOfLines={4} fontSize={10} fontWeight={"normal"} color={"brand.gray"}
              textTransform={"capitalize"}>{description}
        </Text>
        <Text fontSize={10} fontWeight={"500"} color={"brand.grey"} textTransform={"capitalize"}
              mt={2.5}>{teacher}</Text>
      </Box>
    </Grid>
  );
}

export default Lesson;